export const basePath = 'docs';
